import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import API from '@sesame/web-api';
import { useAuth0 } from '@auth0/auth0-react';

import { Spinner } from 'src/components/Spinner';
import { ILoadState, IRack, IComponent, ISalesorder } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';

export default function RackPage() {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [rack, setRack] = useState<IRack>();
  const [rackId, setRackId] = useState(0);
  const [displayState, setDisplayState] = useState<ILoadState>(ILoadState.NEW);
  const [salesorder, setSalesorder] = useState('')

  const getRack = async (reqRackId: number) => {
    const accessToken = await getAccessTokenSilently();
    const resp = await API.get(accessToken, `/api/v1/rack/${reqRackId}`)
      .catch(err => {
        Alert(AlertTypes.ERROR, err.message);
        setDisplayState(ILoadState.ERROR);
      });
    const newRack = resp.data as IRack;
    setRack(newRack);
    setRackId(newRack.rackId);
    getSalesorder(newRack.salesorderId);
    setDisplayState(ILoadState.READY);
  }

  const getSalesorder = async (salesorderId: number) => {
    const accessToken = await getAccessTokenSilently();
    const resp = await API.get(accessToken, `/api/v1/salesorder/${salesorderId}`)
    const salesorder = resp.data as ISalesorder;
    setSalesorder(salesorder.salesorderRef);
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryRackId = parseInt(queryParams.get('rack') || '0');
    getRack(queryRackId);
  }, [getAccessTokenSilently]);

  if (displayState == ILoadState.NEW || displayState == ILoadState.LOADING || !rack) {
    return <div className="uk-container">
      <Spinner />
    </div>
  }
  if (displayState == ILoadState.ERROR) {
    return <div className="uk-container">
      <h2>Rack</h2>
      <p>Error loading rack</p>
    </div>
  }
  return <div className="uk-container">
    <h1 >Rack Details</h1>
    {rack.identifier} - {rack.bomPartNumber} : {rack.revision}
    <br />
    {rack.description}
    <br />
    <a href={`/rackElevation?rack=${rack.rackId}`}>Edit Elevation</a>
    <br />
    <a href={`/rackSerials?rack=${rack.rackId}`}>Enter Serial Numbers</a>
    <br />
    Sales Order: <a href={`/editSalesOrder?salesorder=${rack.salesorderId}`}>{salesorder}</a>
    <br />
    <br />
    Fetch JSON via CLI with:
    <pre>curl -H "Authorization: Bearer $&#123;PARSLEY_AUTH_TOKEN&#125;"
      -X GET "{window.location.protocol}//{window.location.hostname}/api/v1/rack/{rack.rackId}/components"</pre>
    <br />
    <RackComponents rackId={rackId} />
  </div>
};

interface IRackComponentsProps {
  rackId: number;
}


const RackComponents = ({ rackId }: IRackComponentsProps) => {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [components, setComponents] = useState<IComponent[]>([]);
  const [displayState, setDisplayState] = useState<ILoadState>(ILoadState.NEW);

  const getComponents = async (rackId: number) => {
    const accessToken = await getAccessTokenSilently();
    const resp = await API.get(accessToken, `/api/v1/rack/${rackId}/components`)
      .catch(err => {
        setDisplayState(ILoadState.ERROR);
      });
    setComponents(resp.data as IComponent[]);
    setDisplayState(ILoadState.READY);
  }

  useEffect(() => {
    console.log('Getting components for ' + rackId);
    getComponents(rackId);
  }, [getAccessTokenSilently]);

  if (isLoading || displayState == ILoadState.NEW || displayState == ILoadState.LOADING) {
    return <div>
      <Spinner />
    </div>
  }
  if (displayState == ILoadState.ERROR) {
    return <div>
      <p>Error loading rack</p>
    </div>
  }

  const maxLevel = components.reduce((p: number, c) => { return (c.level || 0) > p ? (c.level || 0) : p }, 0);
  return <table className="uk-table uk-table-small">
    <tbody>
      {components.map(c => <tr key={c.componentId}>
        <td>
          {[...Array(c.level! - 1)].map((e, i) => <span data-uk-icon="chevron-double-right" />)}
          {c.partNumber} : {c.revision}
        </td>
        <td>| {c.name}</td>
      </tr>
      )}
    </tbody>
  </table>
}
